// extracted by mini-css-extract-plugin
export default {"warning":"WarningMessage__warning--1-3"};